import { render, staticRenderFns } from "./TemplateCollectionDetails.vue?vue&type=template&id=5f39e3f4"
import script from "./TemplateCollectionDetails.vue?vue&type=script&lang=js"
export * from "./TemplateCollectionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports